export default __webpack_public_path__ + "static/media/logout.246e56bd.webp";